import script from "./tag.vue?vue&type=script&setup=true&lang=ts"
export * from "./tag.vue?vue&type=script&setup=true&lang=ts"

import "./tag.vue?vue&type=style&index=0&id=b10d01e4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b10d01e4"]])

export default __exports__